import { IKeyValue } from "motw_core/Entity/IKeyValue";
import * as React from "react";
import { GetDefaultKeyValue } from "source/app/infrastructure/Data/KeyValues/defaultKeyValue";
import { UpdateKeyValueAsync } from "source/app/infrastructure/Data/KeyValues/UpdateKeyValue";
import { Sounds } from "source/app/services/Sound/Sounds";
import { ShareState } from "source/app/services/UI/State/ShareState";
import { ESharedFunction } from "../../../../../../motw_core/Enums/ESharedFunction";
import { FormSelect } from "../../Shared/Form/Select/FormSelect";
import { GetVerbIconColor, VerbIcon } from "../../Shared/RPGIcon/VerbIcons.tsx/VerbIcons";
import { StyleClass } from "../../Shared/Styles/CSS";
import { SetState } from "source/app/services/UI/State/SetState";
import VerbConstants from "../../../../../../motw_core/Constants/VerbConstants";

export function BroadStateSelector({
    sharedFunction,
    verbSymbol,
    rotateDegrees,
}: {
    sharedFunction: ESharedFunction;
    verbSymbol: string;
    rotateDegrees: number;
}) {
    const [keyValue, setKeyValue] = React.useState<IKeyValue>(
        GetDefaultKeyValue()
    );
    const [isHovered, setIsHovered] = React.useState(false);

    ShareState(sharedFunction, keyValue, setKeyValue);

    const styleClass = StyleClass(`broadStateSelector_container`, {
        display: `block`,
        margin: 0,
        position: `absolute`,
        left: "50%",
        top: "50%",
        width: `48px`,
        height: `48px`,
        opacity: 1.0,
    });

    const tooltip = VerbConstants.GetTarget(verbSymbol);
    const stationColor = GetVerbIconColor(verbSymbol);

    const elementStyle = {
        transform: `translate(-50%, -50%) rotate(${rotateDegrees}deg) translateX(94px)`,
    };

    return (
        <span
            className={styleClass}
            style={elementStyle}
            data-tip={tooltip}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <span
                aria-hidden="true"
                style={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    width: "34px",
                    height: "34px",
                    pointerEvents: "none",
                    transform: `translate(-50%, -50%) rotate(${45 - rotateDegrees}deg)`,
                    background: isHovered ? `${stationColor}18` : "transparent",
                    border: isHovered ? `1px solid ${stationColor}` : "1px solid transparent",
                    boxShadow: isHovered
                        ? `0 0 7px ${stationColor}, 0 0 18px ${stationColor}`
                        : "none",
                    transition: "background 140ms ease, border-color 140ms ease, box-shadow 180ms ease",
                }}
            />
            <div
                style={{
                    transform: `translate(-50%, -50%) rotate(${-1 * rotateDegrees}deg)`,
                    position: `absolute`,
                    top: `50%`,
                    left: `50%`,
                    width: `24px`,
                    filter: "drop-shadow(0 0 4px rgba(110, 190, 145, 0.35))",
                }}
            >
                <VerbIcon verbSymbol={verbSymbol} />
            </div>
            <div
                style={{
                    transform: `translate(14px, -50%) rotate(${-1 * rotateDegrees}deg)`,
                    position: `absolute`,
                    top: `50%`,
                    left: `50%`,
                    width: "42px",
                    height: "24px",
                }}
            >
                <span
                    aria-hidden="true"
                    style={{
                        position: "absolute",
                        inset: 0,
                        clipPath:
                            "polygon(5px 0, calc(100% - 5px) 0, 100% 5px, 100% calc(100% - 5px), calc(100% - 5px) 100%, 5px 100%, 0 calc(100% - 5px), 0 5px)",
                        background: isHovered ? stationColor : "#9d6e32",
                        boxShadow: isHovered
                            ? `0 0 7px ${stationColor}`
                            : "0 0 5px rgba(177, 128, 61, 0.3)",
                        transition:
                            "background 140ms ease, box-shadow 180ms ease",
                    }}
                >
                    <span
                        style={{
                            position: "absolute",
                            inset: "1px",
                            clipPath:
                                "polygon(4px 0, calc(100% - 4px) 0, 100% 4px, 100% calc(100% - 4px), calc(100% - 4px) 100%, 4px 100%, 0 calc(100% - 4px), 0 4px)",
                            background: "rgba(8, 9, 8, 0.94)",
                        }}
                    />
                </span>
                <FormSelect
                    id={`broadStateSelector_${verbSymbol}`}
                    width="42px"
                    style={{
                        position: "absolute",
                        inset: 0,
                        height: "24px",
                        margin: 0,
                        padding: "2px 5px",
                        lineHeight: 1,
                        border: "none",
                        borderBottom: "none",
                        boxShadow: "none",
                        background: "transparent",
                        color: isHovered ? stationColor : "#d8ccb5",
                        fontFamily: '"IM Fell French Canon SC", serif',
                        fontSize: "15px",
                        letterSpacing: "0.04em",
                        textAlign: "center",
                        textShadow: isHovered
                            ? `0 0 5px ${stationColor}, 0 0 12px ${stationColor}`
                            : "0 0 5px rgba(177, 128, 61, 0.45)",
                        transition: "color 140ms ease, text-shadow 180ms ease",
                    }}
                    suggestions={values}
                    onChange={(event: any) => {
                        Sounds.kickdrum_heavy.Play({ allowConcurrent: true });

                        SetState<string>(
                            ESharedFunction.BroadStateSelectors_keyValueUpdateTime,
                            new Date().toString()
                        );

                        UpdateKeyValueAsync(sharedFunction, event.target.value);
                    }}
                    value={keyValue.value}
                />
            </div>
        </span>
    );
}

var values = ["0", "0.5", "1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5"];
